import {
  cleanText,
  cleanNumbers,
  cleanUnsafe,
  isEmail,
  onInputText,
  onInputNumbers,
  onInputUnsafe,
  onPasteText,
  onPasteNumbers,
  onPasteUnsafe,
} from "@/utils/inputCleaners";

export default {
  methods: {
    cleanText,
    cleanNumbers,
    cleanUnsafe,
    isEmail,
    onInputText,
    onInputNumbers,
    onInputUnsafe,
    onPasteText,
    onPasteNumbers,
    onPasteUnsafe,
  },
};
